const DEVICE_ID_KEY = 'sonata_device_id';
let cachedDeviceId: string | undefined;

const generateId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return Math.random().toString(36).slice(2);
};

export const getDeviceId = (): string | undefined => {
  if (cachedDeviceId) return cachedDeviceId;
  if (typeof localStorage === 'undefined') return undefined;
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY);
    if (existing) {
      cachedDeviceId = existing;
      return existing;
    }
    const next = generateId();
    localStorage.setItem(DEVICE_ID_KEY, next);
    cachedDeviceId = next;
    return next;
  } catch (err) {
    console.warn('[device-id] Failed to resolve device id', err);
    return undefined;
  }
};
